import FpSimpleTree from './FpSimpleTree'

export default FpSimpleTree
